// @flow
import { connect } from 'react-redux';
import { compose } from 'react-recompose';
import ChooseRegion from './ChooseRegion.container';
import { CommonActions } from '@react-navigation/native';
import Navigation from '../../../lib/navigation';

type DispatchProps = {
  goToNextPage: Function,
};

const mapDispatchToProps: Function = (): DispatchProps => ({
  goToNextPage: () => Navigation.dispatch(CommonActions.navigate({ name: 'choosePlan' })),
});

export default compose(connect(null, mapDispatchToProps))(ChooseRegion);
